import React from 'react';
import styled from 'styled-components';
import SVG, {Props as SVGProps} from 'react-inlinesvg';

import {transformSizePropToSize} from '../../../utils/common';
import {BaseIconContainer} from 'styled/common';

import questionCircle from '../../../assets/icons/icon-question-circle.svg';
import whiteArrowRight from '../../../assets/icons/arrowNext.svg';
import trash from '../../../assets/icons/rubbish-bin.svg';
import camera from '../../../assets/icons/camera.svg';
import picture from '../../../assets/icons/picture-icon.svg';
import close from '../../../assets/icons/close-icon.svg';
import padlock from '../../../assets/icons/padlock.svg';
import backArrow from '../../../assets/icons/back-arrow.svg';
import arrowRightBlue from 'assets/icons/arrow-right-icon-blue.svg';
import thunder from 'assets/icons/tunder_icon.svg';
import editIcon from 'assets/icons/edit-icon.svg';
import questionCircleBlue from 'assets/icons/question-icon.svg';
import warningSecondary from 'assets/icons/warning-secondary.svg';
import checkSecondary from 'assets/icons/check-secondary.svg';
import creditCardBlue from 'assets/icons/credit-card-blue.svg';
import checkOutCalendar from 'assets/icons/check-out-calendar.svg';
import checkInCalendar from 'assets/icons/check-in-calendar.svg';
import multiGuest from 'assets/icons/multi-guest.svg';
import backBlueArrow from 'assets/icons/back-blue-arrow.svg';
import plusBlueIcon from 'assets/icons/plus-blue-icon.svg';
import deleteItemBox from 'assets/icons/delete_item_box.svg';
import information from 'assets/icons/information.svg';
import grayRightArrow from 'assets/icons/gray-right-arrow.svg';
import allianzShieldIcon from 'assets/icons/allianz-shield-icon.svg';

export type IconNames =
  | 'questionCircle'
  | 'whiteArrowRight'
  | 'trash'
  | 'camera'
  | 'picture'
  | 'close'
  | 'padlock'
  | 'backArrow'
  | 'arrowRightBlue'
  | 'editIcon'
  | 'thunder'
  | 'questionCircleBlue'
  | 'warningSecondary'
  | 'checkSecondary'
  | 'creditCardBlue'
  | 'checkOutCalendar'
  | 'checkInCalendar'
  | 'multiGuest'
  | 'backBlueArrow'
  | 'plusBlueIcon'
  | 'deleteItemBox'
  | 'information'
  | 'grayRightArrow'
  | 'allianzShieldIcon';

export type IconsHash = {
  [K in IconNames]: string;
};

const icons: IconsHash = {
  questionCircle,
  whiteArrowRight,
  trash,
  camera,
  picture,
  close,
  padlock,
  backArrow,
  arrowRightBlue,
  editIcon,
  thunder,
  questionCircleBlue,
  warningSecondary,
  checkSecondary,
  creditCardBlue,
  checkOutCalendar,
  checkInCalendar,
  multiGuest,
  backBlueArrow,
  plusBlueIcon,
  deleteItemBox,
  information,
  grayRightArrow,
  allianzShieldIcon,
};

export type IconProps = {
  name: IconNames;
  title?: string;
  className?: string;
  size?: string | number;
  transform?: string | number;
  color?: string;
} & React.HTMLAttributes<SVGElement> &
  React.HTMLAttributes<SVGProps>;

const StyledSVGIcon = styled(SVG)<{
  src: string;
  color?: string;
  size?: string | number;
}>`
  width: ${props => transformSizePropToSize(props.size) || '24px'};
  height: ${props => transformSizePropToSize(props.size) || '24px'};
  fill: ${props => props.color || 'none'};
  color: ${props => props.color || 'none'};

  path {
    fill: ${props => props.color || 'currentColor'};
  }
`;

const CustomIcon = (props: IconProps) => {
  return (
    <BaseIconContainer size={props.size}>
      <StyledSVGIcon
        src={icons[props.name]}
        size={props.size}
        width={props.size}
        height={props.size}
        title={props.title || props.name}
        color={props.color || 'transparent'}
        className={props.className}
      />
    </BaseIconContainer>
  );
};

export default CustomIcon;
